import { Dispatch, SetStateAction } from "react";
import TextInput from "../../../components/form-fields/TextInput";
import { removeExtraSpaces } from "../../../helpers/shared/formHandlers";
import { ContractorType } from "../type";

interface TextInputsProps {
  state: ContractorType;
  field: any;
  fieldsName: string[];
  t: any;
  setFormState: Dispatch<SetStateAction<ContractorType>>;
  validateField: (name: string, value: unknown, newData?: Record<string, unknown>) => void;
}

const TextInputs: React.FC<TextInputsProps> = ({ state, field, fieldsName, setFormState, validateField, t }) => {
  return (
    <>
      {fieldsName.map(inputField => (
        <TextInput
          key={inputField}
          aria-label={`fieldsName`}
          {...field[inputField]}
          value={state[inputField as keyof ContractorType]}
          label={t(`${inputField}`)}
          onBlur={removeExtraSpaces(inputField, setFormState, validateField)}
        />
      ))}
    </>
  );
};

export default TextInputs;
